<template>
    <div class="tools-cards" v-on:mouseover="mouseover" v-on:mouseleave="mouseleave" @click="goToRoute(view.access_url)" v-if="!isMobile">
        <div class="card__absolute">
            <span v-if="view.end_of_life_policy != null"
                class="card__badge__end__up"
                data-toggle="tooltip" data-placement="bottom"
                data-html="true"
                :title="`${t.office_tools_end_up} ${endSupport} <br/> ${t.office_tools_end_of_life_policy} ${endLife}`">
                <img :src="`/internacional/public/office5/img/general-svg/legacy.svg`">
                <h1>{{ t.office_tools_end_up + ' ' + endSupport }}</h1>
            </span>
            <span v-if="view.end_of_life_policy == null && view.is_legacy"
                class="card__badge__legacy">
                <img :src="`/internacional/public/office5/img/general-svg/legacy_red.svg`">
                <h1>Legacy</h1>
            </span>
            <span v-if="view.beta_test"
                  class="card__badge__beta__test">
                <img :alt="view.name" :src="`/internacional/public/office5/img/general-svg/beta_icon.svg`">
                <h1>Beta</h1>
            </span>
            <span v-if="view.is_new"
                class="card__badge__new">
                <h1>New</h1>
            </span>
        </div>
        <div class="card__content">
            <div class="header__tool">
                <div class="card_logo">
                    <img v-show="icon === 2" :alt="view.name" :src="`/internacional/public/office5/img/tools/default/${view.image}`">
                    <img v-show="icon === 1" :alt="view.title" :src="`/internacional/public/office5/img/tools/hover/${view.image}`">
                    <img v-show="icon === 3" :alt="view.title" :src="`/internacional/public/office5/img/tools/is_active/${view.image}`">
                </div>
                <h3 v-html="view.title"></h3>
            </div>
            <div class="body__tool" v-if="Description">
                <span>{{view.short_description}}</span>
            </div>
            <div class="body__tool" v-else-if="!Description">
                <span>{{view.description}}</span>
            </div>
        </div>
        <div class="card__actions" @mouseover="canGoToRoute = false" @mouseleave="canGoToRoute = true">
            <div class="footer__help" v-if="view.is_available === true">
                <div class="help__help text-left" v-if="view.knowledge_base_url == null && data.father_is_builderall">
                    <a
                        v-if="Description"
                        class="buttons_card btn-1"
                        @click="LearnMore(false)"
                        v-text="t.label_learn_more">
                    </a>
                    <a
                        v-else-if="!Description"
                        class="buttons_card btn-1"
                        @click="LearnMore(true)"
                        v-text="t.dns_go_back">
                    </a>
                </div>
                <div class="help__help text-left" v-else-if="view.knowledge_base_url != null && data.father_is_builderall">
                    <a
                        class="buttons_card btn-1"
                        :href="view.knowledge_base_url"
                        target="_blank"
                        v-text="t.label_learn_more">
                    </a>
                </div>
                <div class="help__trainning text-right">
                    <a
                        class="buttons_card btn-2"
                        :class="!data.father_is_builderall ? 'growth-button-width' : ''"
                        :href="view.access_url"
                        target="_blank"
                        v-text="t.btn_tool_enter">
                    </a>
                </div>
            </div>
            <div class="footer__help" v-else-if="view.is_available === false">
                <div class="help__trainning">
                    <button class="buttons_card unavailable"
                        @click="upgradePlan()">
                        <img :src="`/internacional/public/office5/img/general-svg/lock_yellow.svg`">
                        {{t.upgrade}}
                    </button>
                </div>
            </div>
        </div>
    </div>
    <a class="tools-cards-mobile" v-else-if="isMobile && view.is_available === true" :href="view.access_url" target="_blank">
        <div class="card-front">
            <img :alt="view.name" :src="`/internacional/public/office5/img/tools/default/${view.image}`">
            <div class="tools-cards-mobile-title" v-html="view.title"></div>
        </div>
    </a>
    <button class="tools-cards-mobile locked" v-else-if="isMobile && view.is_available === false" @click="upgradePlan()">
        <div class="card-front">
            <img :alt="view.name" :src="`/internacional/public/office5/img/tools/default/${view.image}`">
            <div class="tools-cards-mobile-title" v-html="view.title"></div>
        </div>
    </button>
</template>

<script>
export default {
    name: 'tools-cards',
    props: {
        view: {
            type: Object,
            default: function() {
                return {
                    name: 'TITULO',
                    tools_id: -1,
                    url: '#',
                    buttonText: 'teste',
                    src: '?', // pegar icone padrao
                    additional_info: {
                        title: "Subtitulo qualquer"
                    }
                }
            }
        },
        t: {
            type: Object,
        },
        data: {
            type: Object,
        },
        isMobile: {
            type: Boolean,
        }
    },
    data: function() {
        return {
            Description: true,
            icon: 2,
            locale: this.data.lang == 'us' ? 'en' : this.data.lang,
            canGoToRoute: true
        }
    },
    mounted() {
        $('[data-toggle="tooltip"]').tooltip();
    },
    methods: {
        LearnMore(button) {
            this.Description = button
        },
        mouseover: function(){
            this.icon = 1
        },
        mouseleave: function(){
            this.icon = 2
        },
        upgradePlan() {
            window.open(`/${this.data.lang}/office/upgrade?tool=${this.view.name}`, '_blank')
        },
        formatData: (val, locale) => {
          moment.locale(locale)
          return moment(new Date(val)).format('L')
        },
        goToRoute(route){
            if(this.canGoToRoute)
            {
                window.open(route, '_blank');
            }
        }
    },
    computed: {
      endSupport() {
        return this.formatData(this.view.end_of_support, this.locale)
      },
      endLife() {
        return this.formatData(this.view.end_of_life_policy, this.locale)
      }
    }
}
</script>

<style lang="scss" scoped>
@import "../../../../scss/office";
@import '../../../../scss/extras/_variables';

.tools-cards {
    max-width: 500px;
    border: 1px solid transparent;
    min-height: 302px;
    background-color: $dv5-color4;
    border-radius: 7px;
    margin: 0;
    transition: 0.4s;

    &.upgrade {
        background-color: $dv5-color7;
        border: 3px solid $dv5-color8;
    }

    .btn-2 {
        transition: 0.4s;
        background-color: #e6f3ff;
        border: 1px solid $dv5-color1;
        color: $dv5-color1;
        &:hover {
            background-color: $dv5-color1;
            color: #fff;
        }
    }

    .unavailable {
        flex-direction: row !important;
        min-width: 10rem !important;
        justify-content: space-evenly !important;
        background-color: $dv5-color9;
        color: $dv5-color7;
        text-align: center;
        transition: 0.4s;
        padding: 0 1rem;
        border: none;
    }

    &:hover{
        transition: 0.4s;
        margin: 0rem 0rem 0rem 0rem;
        border: 1px solid $dv5-color1;
        cursor: pointer;

        .unavailable {
            padding: 0 1rem;
            transition: 0.4s;
            background-color: $dv5-color9;
            color: $dv5-color7;
            text-align: center;
        }

        .card__content > .body__tool {
        }
        .card__content > .body__tool::-webkit-scrollbar {
            width: 6px;
        }
    }

    .growth-button-width {
      min-width: 10rem !important;
    }
}
.card__content {

    padding: .3rem .3rem 0rem .3rem;
    // max-height: 220px;
    min-height: 240px;
    word-break: break-word;
    word-wrap: break-word;

    .header__tool {
        display: flex;
        flex-direction: row;
        align-items: center;
        text-align: left;
        word-break: break-word;
        word-wrap: break-word;
        .card_logo{
            size: auto;
        }
        img {
            height: 5.625rem;// 90px;
            margin-right: 0.52vw;//10px;
        }
        h3 {
            margin: .5em 0;
            color: $dv5-color1;
            font-size: 1rem;
        }
    }
    .body__tool {
        text-align: left;
        height: 6.8rem;
        overflow-y: hidden;
        overflow-x: hidden;
        margin: 1rem;

        h3 {
            margin: 14px 0px 10px 0px;
            font-family: 'Lato';
            font-size: 1.5rem;
            font-weight: 800;
            line-height: 1.2rem;
            color: #333333;
        }
        span {
            font-family: 'Muli';
            font-size: 14px;
            text-align: justify;
        }
    }
}
.card__actions {
    display: flex;
    align-items: center;
    justify-content: space-around;
    &:hover{
        cursor: default;
    }
    .footer__help {
        display: flex;
        height: 100%;
        width: 100%;
        align-items: center;
        padding: 0 0 .5rem .3rem;
        justify-content: center;
        flex-wrap: wrap;
        // border-top: 0.6px solid rgba(91, 91, 91, 0.5);

        div {
            flex: 1;
            display: inherit;
            align-items: center;
            margin: 0.6rem 0;
            flex-direction: column;

            &.help__trainning {
                //border-left: 0.6px solid rgba(91, 91, 91, 0.5);
            }


            &.help__trainning > a, &.help__help > a {
                svg {
                    display: none;
                    margin: auto;
                    margin-top: 8px;
                }
            }
            /*a {
                font-size: .55rem;
                text-transform: uppercase;
                color: $dv5-color1;
                font-weight: bold;
                &.disabled {
                    filter: opacity(0.5) grayscale(1);
                    pointer-events: none;
                }
            }*/
        }
        .help__help__us a {
            display: flex;
            align-items: center;
            color: $dv5-color1;
            font-weight: bold;
            font-size: .95rem;
            text-transform: capitalize;
            svg {
                margin-right: 10px;
                width: 27px;
                height: auto;
            }
        }
    }

    .footer__actions {
        display: grid;
        grid-template-columns: 1fr 1fr;
        gap: 0.5rem;
    }
    .footer__actions__us {
        padding: 0 10px;
        .button3 {
            width: 100%;
            padding: 1rem 2rem;
            background: #e6f3ff;
            color: $dv5-color1;
            border: 1px solid $dv5-color1;
        }
    }

}

.buttons_card {
    //padding: 0.8em 2.5em 0.8em 2.5em;
    border-radius: 6px;
    margin: 0 .2em 0 .2em;
    display: flex;
    align-items: center;
    flex-direction: column;
    justify-content: center;
    height: 2.6rem;
    width: auto;
    min-width: 6.3rem;
}

.btn-1 {
    background-color: transparent;
    border: 0;
    width: 6rem;
    color: $dv5-color1;
    &:hover{
        transition: 0.4s;
        background-color: $dv5-color1;
        color: #fff;
    }
}

.card__absolute{
    // position: absolute;
    margin-right: .5em;
    display: flex;
    // width: 80%;
    // max-width: 260px;
    justify-content: flex-end;

    .card__badge__end__up,
    .card__badge__beta__test,
    .card__badge__legacy,
    .card__badge__new{
        font-weight: 1000;
        font-family: 'Muli';
        text-transform: capitalize;
        font-size: .7em;

        display: flex;
        padding: 5px;
        flex-direction: row;
        align-items: center;
        justify-content: center;

        border-radius: 0 0 5px 5px;
        width: auto;
        min-width: 3rem;
        height: 2.5em;
        margin-bottom: -2.5rem!important;

        h1 {
            font-family: $dv5-font2;
            font-size: 1.3em;
            margin: 0 0 0 .3em;
            font-weight: bold;
        }
    }

    .card__badge__new{
        margin: 0 .25em;
        background-color: $dv5-color1;
        color: white;
    }
    .card__badge__legacy {
        margin: 0 .25em;
        background-color: $dv5-color10;
        color: $dv5-color11;
    }
    .card__badge__end__up {
        margin: 0;
        background-color: rgba(221, 221, 221, 0.33);
        color: $dv5-color11;
    }
    .card__badge__beta__test{
        margin: 0 .25em;
        background: #e6f3ff;
        color: $dv5-color1;
    }
}

.tools-cards-mobile {
    background-color: $dv5-color4;
    margin: 2px;
    border-radius: 4px;
    border: 0;

    width: 96%;
    height: 175px;

    &.locked{
        opacity: .6;
    }
    .card-front {
        height: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;

        img {
            width: 124px;
            height: 124px;
        }

        .tools-cards-mobile-title{
            text-align: center;
            color: $dv5-color2;
            font-weight: bold;
            padding: 0 4px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/office/js/components/dashboard-v5/tool/ToolsCards.vue